import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import * as React from 'react';
import styled from 'styled-components';

const Main = styled.div`
  background: ${colorsV2.white100};
  box-shadow: ${shadows.zIndex1};
  overflow: hidden;

  ${fromScreen(600)} {
    border-radius: 8px;
  }
`;

interface SectionAudioQuizLayoutProps {
  header?: React.ReactNode;
  player?: React.ReactNode;
  body?: React.ReactNode;
  footer?: React.ReactNode;
  shadowing?: React.ReactNode;
}

export const SectionAudioQuizLayout = (props: SectionAudioQuizLayoutProps) => {
  const { header, player, body, footer, shadowing } = props;

  return (
    <Main className="section-audio-quiz-layout">
      {header}
      {player}
      {body}
      {footer}
      {shadowing}
    </Main>
  );
};
